/**
 * CoureHub.Addressbook.Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AddressBookContactRequestDto } from '../model/addressBookContactRequestDto';
import { AddressBookContactResponseDto } from '../model/addressBookContactResponseDto';
import { AllAddressBookContactResponseDto } from '../model/allAddressBookContactResponseDto';
import { ContactUpdateRequetDto } from '../model/contactUpdateRequetDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class AddressBookContactService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param contactId 
     * @param addressbookId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAddressBookContactDeletAddressBookContactContactIdAddressbookIdDelete(contactId: string, addressbookId: string, observe?: 'body', reportProgress?: boolean): Observable<AddressBookContactResponseDto>;
    public apiAddressBookContactDeletAddressBookContactContactIdAddressbookIdDelete(contactId: string, addressbookId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AddressBookContactResponseDto>>;
    public apiAddressBookContactDeletAddressBookContactContactIdAddressbookIdDelete(contactId: string, addressbookId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AddressBookContactResponseDto>>;
    public apiAddressBookContactDeletAddressBookContactContactIdAddressbookIdDelete(contactId: string, addressbookId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (contactId === null || contactId === undefined) {
            throw new Error('Required parameter contactId was null or undefined when calling apiAddressBookContactDeletAddressBookContactContactIdAddressbookIdDelete.');
        }

        if (addressbookId === null || addressbookId === undefined) {
            throw new Error('Required parameter addressbookId was null or undefined when calling apiAddressBookContactDeletAddressBookContactContactIdAddressbookIdDelete.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AddressBookContactResponseDto>('delete',`${this.basePath}/api/AddressBookContact/DeletAddressBookContact/${encodeURIComponent(String(contactId))}/${encodeURIComponent(String(addressbookId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param ID 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAddressBookContactGetAddressBookContactByIdIDGet(ID: string, observe?: 'body', reportProgress?: boolean): Observable<AddressBookContactResponseDto>;
    public apiAddressBookContactGetAddressBookContactByIdIDGet(ID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AddressBookContactResponseDto>>;
    public apiAddressBookContactGetAddressBookContactByIdIDGet(ID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AddressBookContactResponseDto>>;
    public apiAddressBookContactGetAddressBookContactByIdIDGet(ID: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (ID === null || ID === undefined) {
            throw new Error('Required parameter ID was null or undefined when calling apiAddressBookContactGetAddressBookContactByIdIDGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AddressBookContactResponseDto>('get',`${this.basePath}/api/AddressBookContact/GetAddressBookContactById/${encodeURIComponent(String(ID))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param addressBookId 
     * @param serviceProviderId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAddressBookContactGetAllAddressBookContactGet(addressBookId?: string, serviceProviderId?: string, observe?: 'body', reportProgress?: boolean): Observable<AllAddressBookContactResponseDto>;
    public apiAddressBookContactGetAllAddressBookContactGet(addressBookId?: string, serviceProviderId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AllAddressBookContactResponseDto>>;
    public apiAddressBookContactGetAllAddressBookContactGet(addressBookId?: string, serviceProviderId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AllAddressBookContactResponseDto>>;
    public apiAddressBookContactGetAllAddressBookContactGet(addressBookId?: string, serviceProviderId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (addressBookId !== undefined && addressBookId !== null) {
            queryParameters = queryParameters.set('AddressBookId', <any>addressBookId);
        }
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AllAddressBookContactResponseDto>('get',`${this.basePath}/api/AddressBookContact/GetAllAddressBookContact`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param file 
     * @param addressBookId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAddressBookContactImportAddressBookContactPostForm(file?: Blob, addressBookId?: string, observe?: 'body', reportProgress?: boolean): Observable<AddressBookContactResponseDto>;
    public apiAddressBookContactImportAddressBookContactPostForm(file?: Blob, addressBookId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AddressBookContactResponseDto>>;
    public apiAddressBookContactImportAddressBookContactPostForm(file?: Blob, addressBookId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AddressBookContactResponseDto>>;
    public apiAddressBookContactImportAddressBookContactPostForm(file?: Blob, addressBookId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (file !== undefined) {
            formParams = formParams.append('File', <any>file) as any || formParams;
        }
        if (addressBookId !== undefined) {
            formParams = formParams.append('AddressBookId', <any>addressBookId) as any || formParams;
        }

        return this.httpClient.request<AddressBookContactResponseDto>('post',`${this.basePath}/api/AddressBookContact/ImportAddressBookContact`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAddressBookContactInsertAddressBookPost(body?: AddressBookContactRequestDto, observe?: 'body', reportProgress?: boolean): Observable<AddressBookContactResponseDto>;
    public apiAddressBookContactInsertAddressBookPost(body?: AddressBookContactRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AddressBookContactResponseDto>>;
    public apiAddressBookContactInsertAddressBookPost(body?: AddressBookContactRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AddressBookContactResponseDto>>;
    public apiAddressBookContactInsertAddressBookPost(body?: AddressBookContactRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<AddressBookContactResponseDto>('post',`${this.basePath}/api/AddressBookContact/InsertAddressBook`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAddressBookContactUpdateAddressBookContactPost(body?: ContactUpdateRequetDto, observe?: 'body', reportProgress?: boolean): Observable<AddressBookContactResponseDto>;
    public apiAddressBookContactUpdateAddressBookContactPost(body?: ContactUpdateRequetDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AddressBookContactResponseDto>>;
    public apiAddressBookContactUpdateAddressBookContactPost(body?: ContactUpdateRequetDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AddressBookContactResponseDto>>;
    public apiAddressBookContactUpdateAddressBookContactPost(body?: ContactUpdateRequetDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<AddressBookContactResponseDto>('post',`${this.basePath}/api/AddressBookContact/UpdateAddressBookContact`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
